import Analytics from "features/analytics/Analytics";
import Home from "features/home/Home";
import LocationForm from "features/setup/locations/LocationForm";
import LocationList from "features/setup/locations/LocationList";
import SharingForm from "features/sharings/SharingForm";
import SharingList from "features/sharings/SharingList";
import SubmitForm from "features/submits/SubmitForm";
import SubmitList from "features/submits/SubmitList";
import SubmitsTabs from "features/submits/SubmitsTabs";
import WaiverForm from "features/waivers/WaiverForm";
import WaiverList from "features/waivers/WaiverList";
import WaiverPreviewWrapper from "features/waivers/WaiverPreviewWrapper";
import WaiverSharingDetail from "features/waivers/WaiverSharingDetail";
import WaiverSharings from "features/waivers/WaiverSharings";
import WaiverSubmits from "features/waivers/WaiverSubmits";
import WaiverTabs from "features/waivers/WaiverTabs";
import AdminLayout from "layouts/Admin/AdminLayout";
import PublicLayout from "layouts/PublicLayout";
import { Navigate, Route, Routes } from "react-router-dom";
import ActivityLog from "../features/home/activity-log/ActivityLog";
import BillingDetails from "../features/home/billing-and-plans/BillingDetails";
import Plans from "../features/home/billing-and-plans/Plans";
import ManagePayments from "../features/home/billing-and-plans/manage-payments/ManagePayments";
import IntegrationForm from "../features/home/integrations/IntegrationForm";
import Integrations from "../features/home/integrations/Integrations";
import MyProfile from "../features/home/my-profile/MyProfile";
import Order from "../features/home/order/Order";
import StaffUsers from "../features/home/staff-users/StaffUsers";
import OpenapiKeyForm from "../features/openapis/OpenapiKeyForm";
import OpenapiKeyList from "../features/openapis/OpenapiKeyList";
import useAccess from "../features/profile/useAccess";
import { SharedPublicRoutes } from "./SharedPublicRoutes";

export default function AdminRouter() {
  const access = useAccess();

  return (
    <Routes>
      <Route path="/">
        <Route path="" element={<AdminLayout />}>
          <Route path={""} element={<Home />}>
            {/*<Route path={""} element={*/}
            {/*  access.hasPermissions(PERMISSIONS.MANAGE_BILLINGS_AND_PLANS)*/}
            {/*    ? <BillingAndPlans/>*/}
            {/*    : <MyProfile/>*/}
            {/*}/>*/}

            <Route path={""} key={""} element={<MyProfile />} />
            <Route
              path={"change-email/:token/"}
              key={""}
              element={<MyProfile />}
            />
            <Route path={"manage-payments"} element={<ManagePayments />} />
            <Route path={"plans"} element={<Plans />} />
            <Route path={"billing-details"} element={<BillingDetails />} />
            <Route path={"order"} element={<Order />} />
            <Route
              path={"staff-users"}
              key={"staff-users"}
              element={<StaffUsers />}
            />
            <Route
              path={"recent-activity"}
              key={"recent-activity"}
              element={<ActivityLog />}
            />
            <Route path={"integrations"}>
              <Route path="" element={<Integrations />} />
              <Route path=":integration_id" element={<IntegrationForm />} />
            </Route>
          </Route>
          <Route path="submits" element={<SubmitsTabs />}>
            <Route path="" element={<SubmitList showHeader={false} />} />
            <Route
              path="analytics"
              element={<Navigate to="/submits/analytics/waivers" replace />}
            />
            <Route
              path="analytics/:tab"
              element={<Analytics showHeader={false} />}
            />
            <Route path=":submit_id" element={<SubmitForm />} />
          </Route>
          <Route path="waivers">
            <Route path="" element={<WaiverList />} />
            <Route path=":waiver_id" element={<WaiverTabs />}>
              <Route path="" element={<WaiverPreviewWrapper />} />
              <Route path="edit" element={<WaiverForm />} />
              <Route path="publish" element={<WaiverSharings />}>
                <Route path="" element={<WaiverSharingDetail />} />
                <Route path=":sharing_id" element={<WaiverSharingDetail />} />
              </Route>
              <Route path="submits" element={<WaiverSubmits />} />
            </Route>
          </Route>
          <Route path="sharings">
            <Route path="" element={<SharingList />} />
            <Route path="create" element={<SharingForm />} />
            <Route path=":sharing_id" element={<SharingForm />} />
          </Route>
          <Route path="locations">
            <Route path="" element={<LocationList />} />
            <Route path=":location_id" element={<LocationForm />} />
          </Route>
          <Route path="openapi-keys">
            <Route path="" element={<OpenapiKeyList />} />
            <Route path=":openapi_id" element={<OpenapiKeyForm />} />
          </Route>
        </Route>
      </Route>
      <Route path="/" element={<PublicLayout />}>
        {SharedPublicRoutes}
      </Route>
      <Route path="login" element={<Navigate to="/" />} />
    </Routes>
  );
}
